import React from "react";
import './styles.css'

const CommonScreenContent = ({ children }) => {
    return (
        <div className="commonScreenContent">{children}</div>
    )
}

export default CommonScreenContent